import React from "react";

import { Link, useHistory } from "react-router-dom";

import { useDispatch } from "react-redux";
import { userDataActions } from "reducers/userDataReducer";

import appRoutes, { dashboardRoutes } from "constants/routeConstants";
import logo from "assets/images/company-logo.png";

import { Grid, Image, Menu } from "semantic-ui-react";
import DashboardLink from "./Links/DashboardLink";
import MenuControlButton from "./Buttons/MenuControlButton";
import NotificationButton from "./Buttons/NotificationButton";

const CollectiveMenu = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const logout = () => {
		dispatch(userDataActions.removeToken());
		localStorage.removeItem("user");
		history.replace(appRoutes.LOGIN);
	};
	return (
		<>
			<div
				style={{
					maxHeight: "100vh",
					overflowY: "auto",
					overflowX: "hidden",
					position: "fixed",
					width: "inherit",
				}}
			>
				<Menu vertical fluid>
					<Menu.Header
						style={{
							padding: "0 0 20px 0",
							position: "sticky",
							top: "0",
							background: "white",
							zIndex: "99",
							borderBottom: "1px solid lightgrey",
						}}
					>
						<Grid style={{ marginTop: "0px" }}>
							<Grid.Column
								width={11}
								style={{ marginTop: "0px" }}
							>
								<MenuControlButton
									message="Log out"
									icon="sign-out"
									onClick={logout}
									style={{
										marginLeft: "10px",
										transform: "rotate(180deg)",
									}}
								/>
							</Grid.Column>
							<Grid.Column width={4} style={{ marginTop: "0px" }}>
								<NotificationButton />
							</Grid.Column>
						</Grid>
						<Link to={appRoutes.INDEX}>
							<Image
								src={logo}
								centered
								style={{
									height: "100px",
								}}
							/>
						</Link>
					</Menu.Header>
					{/* Sales Section */}
					<Menu.Item>
						<Menu.Menu style={{ paddingLeft: "20px" }}>
							<Menu.Header style={{ marginBottom: "10px" }}>
								Sales
							</Menu.Header>
							<DashboardLink
								content="Add Sales Record"
								to={dashboardRoutes.ADDSALESRECORD}
							/>
							<DashboardLink
								content="Add Sales Return Record"
								to={dashboardRoutes.ADDSALESRETURN}
							/>
						</Menu.Menu>
					</Menu.Item>
					{/* Purchase Section */}
					<Menu.Item>
						<Menu.Menu style={{ paddingLeft: "20px" }}>
							<Menu.Header style={{ marginBottom: "10px" }}>
								Purchases
							</Menu.Header>
							<DashboardLink
								to={dashboardRoutes.ADDPURCHASERECORD}
								content="Add Purchase Record"
							/>
							<DashboardLink
								content="Add Returned Stock Record"
								to={dashboardRoutes.ADDSTOCKRETURN}
							/>
						</Menu.Menu>
					</Menu.Item>
					{/* Inventory Section */}
					<Menu.Item>
						<Menu.Menu style={{ paddingLeft: "20px" }}>
							<Menu.Header style={{ marginBottom: "10px" }}>
								Inventory
							</Menu.Header>

							<DashboardLink
								content="View Inventory"
								to={dashboardRoutes.VIEWINVENTORY}
							/>
							<DashboardLink
								content="Add Damaged Stock Record"
								to={dashboardRoutes.ADDSTOCKDAMAGED}
							/>
						</Menu.Menu>
					</Menu.Item>
					{/* Products Section */}
					<Menu.Item>
						<Menu.Menu style={{ paddingLeft: "20px" }}>
							<Menu.Header style={{ marginBottom: "10px" }}>
								Products
							</Menu.Header>

							<DashboardLink
								content="View Products"
								to={dashboardRoutes.VIEWPRODUCTS}
							/>
							<DashboardLink
								content="Add Product"
								to={dashboardRoutes.ADDPRODUCTS}
							/>
						</Menu.Menu>
					</Menu.Item>{" "}
					{/* Categories Section */}
					<Menu.Item>
						<Menu.Menu style={{ paddingLeft: "20px" }}>
							<Menu.Header style={{ marginBottom: "10px" }}>
								Categories
							</Menu.Header>
							<DashboardLink
								content="View Categories"
								to={dashboardRoutes.VIEWCATEGORIES}
							/>
							<DashboardLink
								content="Add Category"
								to={dashboardRoutes.ADDCATEGORY}
							/>
						</Menu.Menu>
					</Menu.Item>
					{/* Suppliers Section */}
					<Menu.Item>
						<Menu.Menu style={{ paddingLeft: "20px" }}>
							<Menu.Header style={{ marginBottom: "10px" }}>
								Suppliers
							</Menu.Header>

							<DashboardLink
								content="View Suppliers"
								to={dashboardRoutes.VIEWSUPPLIERS}
							/>
							<DashboardLink
								content="Add Supplier"
								to={dashboardRoutes.ADDSUPPLIER}
							/>
						</Menu.Menu>
					</Menu.Item>
					{/* Reports Section */}
					<Menu.Item>
						<Menu.Menu style={{ paddingLeft: "20px" }}>
							<Menu.Header style={{ marginBottom: "10px" }}>
								Reports
							</Menu.Header>

							<DashboardLink
								to={dashboardRoutes.SALES}
								content="Sales"
							/>

							<DashboardLink
								content="Purchases"
								to={dashboardRoutes.PURCHASES}
							/>

							<DashboardLink
								content="Stock Ledger"
								to={dashboardRoutes.VIEWLEDGER}
							/>
						</Menu.Menu>
					</Menu.Item>
				</Menu>
			</div>
		</>
	);
};

export default CollectiveMenu;
